import { useContext, useState } from "react"
import getPermissaoCurso from "../services/getPermissaoCurso"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"
import postPermissaoCurso from "../services/postPermissaoCurso"
import getCurso from "../services/getCurso"
import { Navigate } from "react-router-dom"
import getServices from "../services/getServices"

const useCursoPermissao = () => {

    const { signOut } = useContext(AuthContext)
    const [submit, setSubmit] = useState(false)
    const [curso, setCurso] = useState(null)
    const [nome, setNome] = useState('')    

    const [coligadas, setColigadas] = useState([])  
    const [coligadasSelecionada, setColigadasSelecionada] = useState([])  

    const [postos, setPostos] = useState([])  
    const [postosSelecionados, setPostosSelecionados] = useState([])  

    const [supervisores, setSupervisores] = useState([])  
    const [supervisoresSelecionados,  setSupervisoresSelecionados] = useState([])  

    const [funcoes, setFuncoes] = useState([])  
    const [funcoesSelecionados,  setFuncoesSelecionados] = useState([])  

    const [funcionarios, setFuncionarios] = useState([])  
    const [funcionariosSelecionados,  setFuncionariosSelecionados] = useState([])      
   
    const [ openPermissaoDialog, setOpenPermissaoDialog ] = useState(false)
    const [ lider, setLider ] = useState(false)

    const _getCurso = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getCurso(`admin/cursos/${id}/`)
        if (result.type === 'success'){
            setNome(result.data.name)
            setCurso(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail === 'Não encontrado.'){
            toast.error(result.data?.detail)
            Navigate('/gestor/cursos') 
        }
        setSubmit(false)
    }

    const _getPermissaoCurso = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getPermissaoCurso(`admin/cursopermissao/${curso.id}/`)
        if (result.type === 'success'){
            setColigadasSelecionada(result.data.coligadas)
            setPostosSelecionados(result.data.postos.map(item=>{return {id:item.id, name: `${item.name} (${item.company?.name})`} }))
            setFuncoesSelecionados(result.data.funcoes.map(item=>{return {id:item.id, name: `${item.name} (${item.company?.name})`} }))
            setSupervisoresSelecionados(result.data.supervisores)
            setFuncionariosSelecionados(result.data.funcionarios)
            setLider(result.data.leader)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }


    const _getColigadas = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/coligada/`)
        if (result.type === 'success'){
            setColigadas(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _getPostos = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/posto/`)
        if (result.type === 'success'){
            setPostos(result.data.map(item=>{return {id:item.id, name: `${item.name} (${item.company?.name})`} }))
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _getSupervisores = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/posto/`)
        if (result.type === 'success'){
            let _supervisores = result.data.map((item)=> item.coordinator)
            setSupervisores(_supervisores)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _getFuncoes = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/funcao/`)
        if (result.type === 'success'){
            setFuncoes(result.data.map(item=>{return {id:item.id, name: `${item.name} (${item.company?.name})`} }))            
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _getFuncionarios = async ()=>{
        
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices(`admin/funcionario/`)
        if (result.type === 'success'){
            setFuncionarios(result.data.map(item=>{return {id:item.user_id, name: `${item.name} (${item?.company})`} }))            
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const _jsonTemplate = ()=> {
        return {
            "cursos" : curso.id,
            "company" : null,
            "user_id": null,
            "leader": false,
            "supervisor": null,
            "postcompany": null,
            "function": null,
        }
    }

    const _permitirCursos = async () =>{

        if (submit){
            return;
        }
        setSubmit(true)

        let jsons = []

        coligadasSelecionada.forEach(async item=>{
            let json = _jsonTemplate()
            json['company'] = item.id
            jsons.push(json)
        })

        postosSelecionados.forEach(async item=>{
            let json = _jsonTemplate()
            json['postcompany'] = item.id
            jsons.push(json)
        })

        supervisoresSelecionados.forEach(async item=>{
            let json = _jsonTemplate()
            json['supervisor'] = item.id
            jsons.push(json)
        })

        funcoesSelecionados.forEach(async item=>{
            let json = _jsonTemplate()
            json['function'] = item.id
            jsons.push(json)
        })

        funcionariosSelecionados.forEach(async item=>{
            let json = _jsonTemplate()
            json['user_id'] = item.id
            jsons.push(json)
        })

        if (lider){
            let json = _jsonTemplate()
            json['leader'] = true
            jsons.push(json)

        }

        let result = await postPermissaoCurso(`admin/cursopermissao/${curso.id}/`, {
            permissoes: jsons
        })
        if (result.type === 'error'){
            toast.error(result.data.detail.status)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
         }
         setSubmit(false)
        return 
    }
    return {
        
        curso:{value:curso,set:_getCurso}, 
        nome:{value:nome,set:setNome}, 
        submit: {value: submit, set: _permitirCursos},

        coligadas: {value: coligadas, set: _getColigadas},     
        coligadasSelecionada: {value: coligadasSelecionada, set: setColigadasSelecionada}, 

        postos: {value: postos, set: _getPostos},     
        postosSelecionados: {value: postosSelecionados, set: setPostosSelecionados},  

        supervisores: {value: supervisores, set: _getSupervisores},     
        supervisoresSelecionados: {value: supervisoresSelecionados, set: setSupervisoresSelecionados},  

        funcoes: {value: funcoes, set: _getFuncoes},     
        funcoesSelecionados: {value: funcoesSelecionados, set: setFuncoesSelecionados},  

        funcionarios: {value: funcionarios, set: _getFuncionarios},     
        funcionariosSelecionados: {value: funcionariosSelecionados, set: setFuncionariosSelecionados},  

        lider: {value:lider, set: setLider},

        buscarPermissaoCurso: {value: ()=>{console.log('não implementado')}, set: _getPermissaoCurso},
        openPermissaoDialog: {value: openPermissaoDialog, set: setOpenPermissaoDialog},
    }
}

export default useCursoPermissao